// @flow
/* -----------------Globals--------------- */
import React from 'react';

const renderItems = (num: number, component: *) => (
  [...Array(num).keys()].map<*>(
    (item: number): * => <React.Fragment key={item}>{component}</React.Fragment>,
  )
);

export {
  // eslint-disable-next-line import/prefer-default-export
  renderItems,
};
